export default Object.freeze({
  // CONTRACT_POPUP_
  STANDARD_TITLE: '입점 표준계약서',
  NORMAL_TITLE: '입점 계약서',
  REGISTER_TITLE: '입점 계약등록',
  REGISTER_CANCEL_TITLE: '입점 계약등록 취소',
  HISTORY_TITLE: '입점 계약내용',
  MODIFICATION_TITLE: '입점 계약내용 변경',
  CANCEL_TITLE: '입점 계약내용 변경 취소',

  STANDARD_MARK: 'ⓘ 입력된 ‘입점 표준계약서’ 의 내용은 ‘파트너 등록’ 시, 파트너사에 따라 적용 또는 수정할 수 있습니다.',
  NORMAL_MARK: 'ⓘ 해당 파트너사에 체결할 ‘입점 계약’ 내용을 입력/수정해주세요.',
  REGISTER_MARK: 'ⓘ 등록된 내용은 파트너사 동의 후, 적용됩니다.',
  REGISTER_CANCEL_MARK1: 'ⓘ 파트너사의 동의가 필요한 입점 계약 내용입니다.',
  REGISTER_CANCEL_MARK2: 'ⓘ \'등록 취소\' 시, 입점 계약내용은 등록되지 않습니다.',
  HISTORY_MARK: 'ⓘ 파트너사가 동의한 입점 계약내용입니다.',
  MODIFICATION_MARK1: 'ⓘ 입점 계약내용 변경 시, 변경 사유도 함께 입력해 주세요.',
  MODIFICATION_MARK2: 'ⓘ 변경된 내용은 파트너사 동의 후, 적용됩니다.',
  CANCEL_MARK1: 'ⓘ 파트너사의 동의가 필요한 입점 계약내용입니다.',
  CANCEL_MARK2: 'ⓘ \'변경 취소\'시, 입점 계약내용은 변경되지 않습니다. (파트너사의 동의가 필요 없으며, 입점 계약 내용이 유지됩니다.)',

  CHANGE_DATE: '계약내용 변경일',
  AGREEMENT_DATE: '동의일',
  CONTENTS: '내용',
  CHANGE_REASON: '변경 사유',

  MODIFICATION_BTN: '변경',
  CANCEL_BTN: '변경 취소',
  REGISTER_BTN: '등록',
  REGISTER_CANCEL_BTN: '등록 취소',

  ERR_CONTENT_NULL: '내용을 입력해 주세요.',
  MODIFICATION_CONFIRM: '입점 계약내용을 변경하시겠습니까?',
  REGISTER_CONFIRM: '입점 계약서를 등록하시겠습니까?',
  REGISTER_CANCEL_CONFIRM: '입점 계약등록을 취소 하시겠습니까?',
  CANCEL_CONFIRM: '입점 계약내용을 변경 취소 하시겠습니까?',
  SUCCESS_MSG: '저장되었습니다.',
  CANCEL_SAVE: '등록 취소',
  CHANGE_REASON_PLACEHOLDER: '입점 계약내용 변경 사유를 입력해주세요.',
  ERR_CHANGE_REASON_NULL: '변경 사유를 입력해주세요.'
});
